export const EVENTS = {
    LANDING_SCREEN: {
        TAP_ON_CHAT: 'TAP_ON_CHAT',
        MESSAGE_SENT: 'MESSAGE_SENT',
    },
    AUTH_SCREEN: {
        OTP_VERIFIED: 'OTP_VERIFIED',
        OTP_NOT_VERIFIED: 'OTP_NOT_VERIFIED',
        TAP_ON_RESEND_OTP: 'TAP_ON_RESEND_OTP',
        TAP_ON_CONTINUE_OTP: 'TAP_ON_CONTINUE_OTP',
        TAP_ON_CONTINUE_MOBILE: 'TAP_ON_CONTINUE_MOBILE',
        TAP_ON_TNS: 'TAP_ON_TNS',
        TAP_ON_VIEW_PP: 'TAP_ON_VIEW_PP',
        TAP_ON_REQUEST_ACCESS: 'TAP_ON_REQUEST_ACCESS',
        TAP_ON_BACK_TO_LOGIN: 'TAP_ON_BACK_TO_LOGIN'
    },
    CONVERSATION_SCREEN: {
        TAP_COPY_ICON: 'TAP_COPY_ICON',
        SELECT_SOURCE_FILE: 'SELECT_SOURCE_FILE',
    },
    TAP_ON_BOTTOM_NAV: 'TAP_ON_BOTTOM_NAV',
    TAP_ON_LOGOUT_ICON: 'TAP_ON_LOGOUT_ICON',
};

export const SCREENS = {
    LOGIN_PAGE: 'login_page',
    LANDING_PAGE: 'landing_page',
    HISTORY_PAGE: 'history_page',
    PROFILE_PAGE: 'profile_page',
    PDF_CHAT: 'pdf_chat_page',
};